import { render, staticRenderFns } from "./BasePcThreeBaiduTop.vue?vue&type=template&id=a70ef752&scoped=true&"
import script from "./BasePcThreeBaiduTop.vue?vue&type=script&lang=ts&"
export * from "./BasePcThreeBaiduTop.vue?vue&type=script&lang=ts&"
import style0 from "./BasePcThreeBaiduTop.vue?vue&type=style&index=0&id=a70ef752&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a70ef752",
  null
  
)

export default component.exports